import styled, { css } from 'styled-components';
import { f as focusOutline } from '../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { i as invertedFocusOutline } from '../theme/style-mixins/FocusIndicator/invertedFocusOutline-BxN_kWq6.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { I as Icon } from '../Icon/Icon-Cgh13Jz2.js';

const linkStyles = /*#__PURE__*/css(["font:", ";", " :focus-visible{", "}", ""], ({
  $size,
  theme
}) => {
  var _theme$font$text$$siz;
  return $size === 'inherit' ? 'inherit' : (_theme$font$text$$siz = theme.font.text[$size]) === null || _theme$font$text$$siz === void 0 ? void 0 : _theme$font$text$$siz.default;
}, ({
  theme,
  $color
}) => {
  if ($color === 'inverted') {
    return css(["color:", ";text-decoration:", ";:hover{color:", ";text-decoration:", ";}:active{color:", ";text-decoration:", ";}"], theme.link.color.inverted, theme.link.decoration.hover, theme.link.color.invertedHover, theme.link.decoration.hover, theme.link.color.invertedHover, theme.link.decoration.hover);
  }
  if ($color === 'text') {
    return css(["color:", ";text-decoration:", ";:hover{color:", ";text-decoration:", ";}"], theme.text.color.default, theme.link.decoration.hover, theme.text.color.default, theme.link.decoration.hover);
  }
  return css(["color:", ";text-decoration:", ";:hover{color:", ";text-decoration:", ";}"], theme.link.color.default, theme.link.decoration.default, theme.link.color.hover, theme.link.decoration.hover);
}, ({
  $color
}) => $color === 'inverted' ? invertedFocusOutline : focusOutline, isMobile(css(["font:", ";"], ({
  $size,
  theme
}) => {
  var _theme$font$text$$siz2;
  return $size === 'inherit' ? 'inherit' : (_theme$font$text$$siz2 = theme.font.text[$size]) === null || _theme$font$text$$siz2 === void 0 ? void 0 : _theme$font$text$$siz2.mobile;
})));
const StyledLink = /*#__PURE__*/styled('a').withConfig({
  componentId: "sc-storm-ui-40025937__sc-1i5mqia-0"
})(["", ""], linkStyles);
StyledLink.displayName = 'StyledLink';
const StyledIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40025937__sc-1i5mqia-1"
})(["font-size:0.85em;"]);

export { StyledLink as S, StyledIcon as a };
//# sourceMappingURL=Link.styles-DPkbdoGT.js.map
